import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ClipboardModule } from 'ngx-clipboard';

import { SharedModule } from 'client/app/modules/shared/shared.module';
import { FontAwesome } from 'client/app/modules/font-awesome/font-awesome.module';

import { MyBuildsRoutingModule } from './my-builds-routing.module';
import { MyBuildComponent } from './my-build/my-build.component';
import { MyBuildsListComponent } from './my-builds-list/my-builds-list.component';


@NgModule({
	declarations: [
		MyBuildComponent,
		MyBuildsListComponent
	],
	imports: [
		CommonModule,
		MyBuildsRoutingModule,
		ReactiveFormsModule,
		NgbModule,
		NgSelectModule,
		ClipboardModule,
		SharedModule,
		FontAwesome
	]
})
export class MyBuildsModule { }
